import Link from "next/link";
import Image from "next/image";
import Text from "@atlas/uicorn/lib/Display/Text";
import MessageIcon from "@atlas/uicorn/lib/Icon/MessageIcon";
import Conversation, { DeliveryType } from "../../../models/conversation";
import EnvelopeIcon from "@atlas/uicorn/lib/Icon/EnvelopeIcon";
import PhoneIcon from "@atlas/uicorn/lib/Icon/PhoneIcon";
import UserAvatar from "../../user-avatar";
import whatsappIcon from "../../../public/icons/whatsapp.png";
import slackIcon from "../../../public/icons/slack-logo.png";
import discordIcon from "../../../public/icons/discord-logo.png";
import Tooltip from "@atlas/uicorn/lib/Display/Tooltip";
import { shortDateTimeDisplay } from "@atlas/tool/box/date/time-ts";
import styles from "../../../styles/conversation-list-item.module.css";
import cssVars from "@atlas/tool/box/style/cssVars";

export default function ConversationListItem({
  conversation,
  baseUrl,
  showCustomer,
  numbersLength,
  namesLength,
}: {
  conversation: Conversation;
  baseUrl: string;
  showCustomer?: boolean;
  numbersLength: number;
  namesLength: number;
}) {
  return (
    <Link
      href={`${baseUrl}/customer-portal/${conversation.id}`}
      className={styles.link}
    >
      {DeliveryTypeIcons[conversation.startedChannel]}
      {numbersLength > 0 && (
        <Text
          className={styles.number}
          style={cssVars({
            "character-width": `${numbersLength + 1}ch`,
          })}
        >
          #{conversation.number}
        </Text>
      )}
      {showCustomer && (
        <Text
          className={styles.customerName}
          style={cssVars({
            "characters-width": `${namesLength < 12 ? namesLength : 12}ch`,
          })}
        >
          {conversation.customer.fullName}
        </Text>
      )}
      {conversation.lastMessage && (
        <Text className={styles.lastMessage} ellipsis>
          {conversation.subject || conversation.lastMessage.plainText}
        </Text>
      )}
      {conversation.assignedAgent?.fullName && (
        <>
          <Text>{conversation.assignedAgent.fullName}</Text>
          <UserAvatar user={conversation.assignedAgent} />
        </>
      )}

      <Text className={styles.date}>
        <Tooltip
          title={
            conversation.lastMessage &&
            `Last updated ${formatDateTime(conversation.lastMessage.sentAt)}`
          }
          placement="top"
        >
          <span>{conversation.lastMessage?.sentAtDisplay}</span>
        </Tooltip>
      </Text>
    </Link>
  );
}

function formatDateTime(date: string) {
  return shortDateTimeDisplay(date);
}

export const DeliveryTypeIcons = {
  [DeliveryType.CHAT]: <MessageIcon />,
  [DeliveryType.EMAIL]: <EnvelopeIcon />,
  [DeliveryType.SMS]: <PhoneIcon />,
  [DeliveryType.WHATSAPP]: (
    <Image width={18} src={whatsappIcon} alt="whatsapp" />
  ),
  [DeliveryType.SLACK_CONNECT]: (
    <Image width={18} src={slackIcon} alt="slack" />
  ),
  [DeliveryType.DISCORD_CONNECT]: (
    <Image width={18} src={discordIcon} alt="discord" />
  ),
};
